<template>
  <div
    class="read-more"
    :class="{ show }"
  >
    {{ text }}
    <div class="arrow-right-wrapper">
      <ButtonArrowRight class="arrow-right" />
    </div>
  </div>
</template>

<script>
import ButtonArrowRight from '~/components/Common/Svg/HomePage/ButtonArrowRight.vue';
export default {
  components: { ButtonArrowRight },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Read more',
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ReadMore.scss';
</style>
